<template>
 <div>
  <label :for="idCampo" :id="`${idCampo}-label`" class="form-label">{{ label }}</label>
  <MultiSelect
   :model-value="selectedObjeto"
   :options="opcoesDisponiveis"
   @update:modelValue="selecionarFornecedor"
   mode = "single"
   :searchable = "true"
   :close-on-select="true"
   valueProp = "valor"
   trackBy = "texto"
   label = "texto"
   placeHolder = "Selecione um Fornecedor"
   :id="idCampo"
   :disabled="disabled || loading"
   :aria="ariaDoCampo"
  />
  <div v-if="mensagemErro" :id="`${idCampo}-erro`" class="invalid-feedback d-block">
   {{ mensagemErro }}
  </div>
 </div>
</template>

 <script lang = "ts">
  import { computed, defineComponent, ref, onMounted, onScopeDispose, PropType, watch } from "vue";
  import servico from "@/services/gestao/fornecedor/fornecedor.service";
  import TextoValor from "@/models/texto-valor";

  let sequenciaFornecedor = 0;

  export default defineComponent({
   name: "DropDownListComponente",
   props: {
    id: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    mensagemErro: { type: String, default: '' },
    ariaDescribedby: { type: String, default: '' },
    modelValue: {
     type: Number as PropType<number | null>,
     default: null,
    },
    tipoFornecedor: {
     type: Number,
     default: null,
    },
    label: {
     type: String,
     default: "Fornecedor:",
    },
   },
   emits:["update:modelValue"],
   setup(props, { emit }) {
    const idGerado = `fornecedor-select-${++sequenciaFornecedor}`;
    const idCampo = computed(() => props.id || idGerado);
    const ariaDoCampo = computed(() => ({
     'aria-labelledby': `${idCampo.value}-label`,
     'aria-invalid': props.mensagemErro ? 'true' : undefined,
     'aria-describedby': [props.ariaDescribedby, props.mensagemErro ? `${idCampo.value}-erro` : ''].filter(Boolean).join(' ') || undefined,
    }));
    const objeto = ref < TextoValor[]>([]);
    const selectedObjeto = computed(() => props.modelValue);
    const nomesConhecidos = new Map<number, string>();
    const opcoesDisponiveis = computed(() => {
     const selecionado = props.modelValue;
     if (selecionado == null || objeto.value.some(item => item.valor === selecionado))
      return objeto.value;
     // Listas filtradas/inativos não devem apagar um vínculo já salvo nem exibi-lo vazio.
     return [...objeto.value, {
      valor: selecionado,
      texto: nomesConhecidos.get(selecionado) || `Fornecedor vinculado (código ${selecionado})`,
     }];
    });
    const loading = ref(false);
    let requisicaoAtual = 0;
    const fetchObjeto = async() => {
     const requisicao = ++requisicaoAtual;
     loading.value = true;
     objeto.value = [];
     try {
      const result = await servico.DropDownList(props.tipoFornecedor);
      if (requisicao !== requisicaoAtual) return;
      result.forEach(item => nomesConhecidos.set(item.valor, item.texto));
      objeto.value = result.map((item) => ({
       valor: item.valor,
       texto: item.texto,
      }));
     } catch (err) {
      if (requisicao !== requisicaoAtual) return;
      console.error("Erro ao carregar Fornecedor:", err);
     } finally {
      if (requisicao === requisicaoAtual) loading.value = false;
     }
    };

    const selecionarFornecedor = (valor: number | null) => {
     if (props.disabled || loading.value) return;
     emit('update:modelValue', valor ?? null);
    };

    watch(
     () => props.tipoFornecedor,
     () => {
      fetchObjeto();
     },
     { flush: 'sync' }
    );

    onScopeDispose(() => { requisicaoAtual++; });
    
    onMounted(fetchObjeto);
     return {
     idCampo,
     ariaDoCampo,
     objeto,
     opcoesDisponiveis,
     selecionarFornecedor,
     selectedObjeto,
     loading,
    };
   },
  });
 </script>
